module.exports = __webpack_public_path__ + "static/media/400014_02.907e661e.png";